import React, {useRef, useState} from 'react';
import {classes, style} from './expandable-text.st.css';
import {useElementLayoutBinding} from "../hooks";
import {Evaluable, evaluateWhenFunction, referencesEqualityComparer} from "@wix/devzai-utils-common";
import {Button} from "../button/button";

export const ExpandableText = React.memo(function ExpandableText (props: ExpandableText.Props) {
    const {
        children,
        seeMoreButtonContent,

        className,
        ...htmlAttributes
    } = props;

    const [isExpanded, setIsExpanded] = useState(false);

    const textContainerRef = useRef<HTMLDivElement>(null);

    const hasEllipsis = useElementLayoutBinding(
        textContainerRef,
        elementHasEllipsis,
        referencesEqualityComparer,
        !isExpanded) ?? false

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {isExpanded: isExpanded, hasEllipsis: hasEllipsis}, className)}
        >
            <div
                className={style(classes.contentWrapper, {})}
            >
                <div
                    className={style(classes.textContainer, classes.testTextContainer)}
                    ref={textContainerRef}
                >
                    {children}
                </div>
                <div
                    className={style(classes.textContainer, {})}
                >
                    {children}
                </div>
                {hasEllipsis && !isExpanded ? (
                    <Button
                        className={style(classes.seeMoreButton, {})}
                        onClick={() => {
                            setIsExpanded(true);
                        }}
                    >
                        {evaluateWhenFunction(seeMoreButtonContent)}
                    </Button>
                ) : null}
            </div>
        </div>
    );
});

export namespace ExpandableText {

    export interface Props extends React.HTMLAttributes<any> {
        children: string;
        seeMoreButtonContent: Evaluable<() => React.ReactNode>;
    }
}

function elementHasEllipsis(element: HTMLElement) : boolean {
    return element.offsetWidth < element.scrollWidth;
}